import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { url } from "components/common/api";

export const machineApi = createApi({
  reducerPath: "machineApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${url}` }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Machine"],
  endpoints: (build) => {
    return {
      fetchMachines: build.query({
        query: () => ({
          url: `/api/machines/`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            Accept: "application/json",
          },
        }),
        providesTags: (result = [], error, arg) =>
          result?.results?.length
            ? [
              ...result.results.map(({ id }) => ({ type: "Machine", id })),
              "Machine",
            ]
            : ["Machine"],
      }),

      getMachine: build.query({
        query: (id) => {
          return {
            url: `/api/machines/${id}/`,
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
              "Content-Type": "application/json",
            },
          };
        },
        providesTags: (result, error, arg) => [{ type: "Machine", id: arg }],
      }),

      createMachine: build.mutation({
        query: (machineData) => {
          return {
            url: `/api/machines/`,
            method: "POST",
            body: machineData,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
              Accept: "application/json",
            },
          };
        },
        invalidatesTags: ["Machine"],
      }),

      updateMachine: build.mutation({
        query: (machineData) => {
          const { id, ...data } = machineData;
          return {
            url: `/api/machines/${id}/`,
            method: "PUT",
            body: data,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
              Accept: "application/json",
            },
          };
        },
        invalidatesTags: (result, error, arg) => [
          { type: "Machine", id: arg.id },
        ],
      }),

      deleteMachine: build.mutation({
        query: (id) => {
          return {
            url: `/api/machines/${id}/`,
            method: "DELETE",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
          };
        },
        invalidatesTags: ["Machine"],
      }),
    };
  },
});

export const {
  useFetchMachinesQuery,
  useGetMachineQuery,
  useCreateMachineMutation,
  useUpdateMachineMutation,
  useDeleteMachineMutation,
} = machineApi;